<template>

     <v-section col="col">
         <div class="uses">
            <div v-for="use in uses" :key="use.title" class="use">
                <div class="ss mb-30">
                    <img :src="use.ss" width="100%" height="auto" :title="use.title" />
                </div>
                <div>
                    <h4 class="mb-15">{{ use.title }}</h4>
                    <p class="small">{{ use.desc }}</p>
                </div>
            </div>
         </div>
    </v-section>

</template>

<style scoped lang="scss">

    .uses {
        display: grid;
        gap: 30px;
        .use {
            display: grid;
            gap: 60px;
            grid-auto-flow: column;
            grid-template-columns: 75% 25%;
            text-align: left;
            width: 100%;
            .ss {
                background: $color-text;
                border-radius: 5px;
                box-shadow: 0 10px 30px rgba(0,0,0,0.2);
                overflow: hidden;
            }
            @media (max-width: map-get($grid-breakpoints, 'lg')) {
                gap: 15px;
                grid-auto-flow: row;
                grid-template-columns: 1fr;
            }
        }
    }

</style>

<script>

export default {

    data() {
        return {
            allUses: [
                {
                    'slug': 'feature-engagement',
                    'ss': '/img/features/feature-engagement1.jpg',
                    'title': 'Automate onboarding',
                    'desc': 'Create set-and-forget automations that send onboarding sequences, re-activate customers, request reviews, prompt for upgrades, and so much more. CrowdPower automates manual tasks so you can focus on building your product.',
                },
                {
                    'slug': 'feature-engagement',
                    'ss': '/img/features/feature-engagement2.jpg',
                    'title': 'Re-activate Customers',
                    'desc': 'Never lose another lead. CrowdPower can automatically bring lapsed customers back into your product by sending an email, push notification, or SMS to them if they haven’t used your product or feature in a while.',
                },
                {
                    'slug': 'feature-engagement',
                    'ss': '/img/features/feature-engagement3.jpg',
                    'title': 'Notify team members',
                    'desc': 'Use our Slack, Discord, and SMS integrations to notify team members of important events, like when a user’s trial ends. You can even send data to thousands of 3rd party apps using our Zapier and Integromat integrations.',
                },
                {
                    'slug': 'feature-management',
                    'ss': '/img/features/feature-management1.jpg',
                    'title': 'All your customers in one place',
                    'desc': 'Get a birds-eye view of your user activity in real-time. See who is using your app, when they use it, what features they use, and more. With CrowdPower, you get a complete customer data platform right out of the box.',
                },
                {
                    'slug': 'feature-management',
                    'ss': '/img/features/feature-management2.jpg',
                    'title': 'Real-time user activity',
                    'desc': 'See every action your customers take with the events feed on user profiles. With CrowdPower, you can send in any action your customers take in your app, and then send messages to them at just the right times.',
                },
                {
                    'slug': 'feature-management',
                    'ss': '/img/features/feature-management3.jpg',
                    'title': 'Complete user profiles',
                    'desc': 'Give everyone in your organization the ability to see every detail about your customers. CrowdPower user profiles display properties, in-app event history, charge history, page history, notes, and more.',
                },
                {
                    'slug': 'feature-segmenting',
                    'ss': '/img/features/feature-segmenting1.jpg',
                    'title': 'Discover your best customers',
                    'desc': 'Easily find your power customers, the ones slipping away, the ones on trial, and the ones paying you. With our powerful segmenting features, you’ll be able to send messages to customers at all stages of the SaaS lifecycle.',
                },
                {
                    'slug': 'feature-segmenting',
                    'ss': '/img/features/feature-segmenting2.jpg',
                    'title': 'Automate messages',
                    'desc': 'Automatically send messages to customers when you need to. With CrowdPower, you can onboard new customers, ask power customers to leave a review, re-activate customers with a promo code, and so much more.',
                },
                {
                    'slug': 'feature-segmenting',
                    'ss': '/img/features/feature-segmenting3.jpg',
                    'title': 'Broadcast to segments',
                    'desc': 'Announce features, offers and webinars to specific groups of customers with ease. With CrowdPower, you can send one-off emails and push notifications to your segments whenever you need to.',
                },
                {
                    'slug': 'feature-email',
                    'ss': '/img/features/feature-email1.jpg',
                    'title': 'Drag & drop builder',
                    'desc': 'We built a custom drag and drop email builder from scratch, built just for SaaS businesses without all the fluff from the one-size-fits-all marketing automation platforms.',
                },
                {
                    'slug': 'feature-email',
                    'ss': '/img/features/feature-email2.jpg',
                    'title': 'Custom domain and senders',
                    'desc': 'Add your own custom sending domain to each project, with as many senders as you need. You can even send unlimited emails with automations using your own SMTP credentials.',
                },
                {
                    'slug': 'feature-email',
                    'ss': '/img/features/feature-email3.jpg',
                    'title': 'Liquid templating engine',
                    'desc': 'Easily plug in variables into your emails with the Liquid Templating Language pioneered by Shopify. Leverage user traits and event properties to personalize messages at scale.',
                },
            ],
        }
    },

    computed: {

        uses() {
            return this.allUses.filter(u => u.slug === this.$route.name);
        },

    },

}

</script>